import { render, staticRenderFns } from "./peopleStudio.vue?vue&type=template&id=373c44b9&scoped=true&"
import script from "./peopleStudio.vue?vue&type=script&lang=js&"
export * from "./peopleStudio.vue?vue&type=script&lang=js&"
import style0 from "./peopleStudio.vue?vue&type=style&index=0&id=373c44b9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373c44b9",
  null
  
)

export default component.exports